import request from "@/utils/request.js";

// 查询所有领料仓库和送货地点配置列表
export function getMaterialWarehouseAndDeliveryLocation(params){
  return request({
    url:"/material/materialapp/api/admin/materialWarehouse/list",
    method:"GET",
   params
  })
}

// 校验领料编号是否已存在
export function verifyMaterialCodeExist(params){
    return request({
        url: "/material/materialapp/api/admin/materialMession/verifyMaterialCodeExist",
        method: "GET",
        params
    })
}